import React from 'react';
import Link from 'components/link';
import ThemedIcon from 'components/themed-icon';

type LogoProps = {
  ariaLabel?: string;
  href?: string;
  logoClassName?: string;
  testId?: string;
  logoComponent?: React.ReactNode;
};

const Logo = ({ 
  ariaLabel = 'Header logo',
  href = '/',
  logoClassName = '',
  testId,
  logoComponent,
}: LogoProps) => {
  return (
    <div data-testid={testId}>
      <Link href={href} as={href} className={logoClassName} rel="noreferrer" ariaLabel={ariaLabel}>
        {logoComponent || <ThemedIcon />}
      </Link>
    </div>
  );
};

export default Logo; 